import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './config/request/queryClient';
import { HostProvider } from './core/contexts/host';
import { useAuth } from './core/hooks/useAuth';
import { useConfigRequest } from './core/hooks/useConfigRequest';
import { useInitDataHubStore } from './core/hooks/useInitDataHubStore';
import useInitHelpers from './core/hooks/useInitHelpers/useInitHelpers';
import { Router } from './core/router';
import { ErrorBoundary } from './shared/components/errorBoundary';
import { Loader } from './shared/components/loader';
import { RootError } from './shared/components/rootError';
import { Toast } from './shared/components/toast';
import { Language } from './shared/constants/languages';
import { LanguageHelper } from './shared/helpers/language';
import 'src/config/i18n';
import 'src/config/polyfill';
import './main.css';
import { useInitSurvey } from './shared/hooks/useInitSurvey';
export function Main({ user, token, product, basename, subdomain, arrivedFrom, membershipId, membershipSlug, language = Language.PtBr, createContentConceptToggle, createModuleConceptToggle, bulkActionMenuToggle, contentListConceptToggle }) {
    const auth = useAuth({ user, token });
    const isAuthenticating = !auth.user;
    const normalizedLanguage = LanguageHelper.normalizeLocale(language);
    useConfigRequest(product.id);
    useInitSurvey({
        language: normalizedLanguage,
        productId: String(product.id),
        userId: user?.id ?? auth.user?.id ?? ''
    });
    const { isInitingHelpers } = useInitHelpers({ language });
    const { isInitingDataHubStore } = useInitDataHubStore({
        membershipId,
        membershipSlug,
        user: user ?? auth.user
    });
    useEffect(function clearQueryCacheOnProductChange() {
        queryClient.clear();
    }, [product.id]);
    if (isAuthenticating || isInitingDataHubStore || isInitingHelpers) {
        return (_jsx("div", { children: _jsx(Loader, { full: "screen", className: "my-12" }) }));
    }
    return (_jsx(ErrorBoundary, { fallback: _jsx(RootError, {}), user: user, children: _jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(HostProvider, { user: auth.user, product: product, subdomain: subdomain, arrivedFrom: arrivedFrom, membershipId: membershipId, language: normalizedLanguage, token: token || auth.user.token, membershipSlug: membershipSlug, createModuleConceptToggle: createModuleConceptToggle, createContentConceptToggle: createContentConceptToggle, bulkActionMenuToggle: bulkActionMenuToggle, contentListConceptToggle: contentListConceptToggle, children: _jsx(Router, { basename: basename }) }), _jsx(Toast, {})] }) }));
}
